import merge from 'lodash/merge';
import { encodeFacets } from '../../utils/jioAdsRelated';

export default function facets(
  state = {
    totalResults: 0,
    currentFacets: {
      results: [],
      entities: {},
      groups: ['category', 'refineBy', 'finerDetails'],
      groupResults: [],
      groupEntities: {}
    },
    nextFacets: {
      results: [],
      entities: {}
    },
    isAdvanceFacetsEnabled: false,
    isPriorityDeliveryOffered: false
  },
  action
) {
  const { type } = action;
  if (type === 'SET_CURRENT_FACETS') {
    const {
      items,
      totalResults = 0,
      isAdvanceFacetsEnabled,
      isPriorityDeliveryOffered,
      enablePriorityDeliveryPhase2,
      enableRushDelivery,
      query = {},
      sessionGenderContext,
      plpGender
    } = action;
    const currentFacets = formatFacets(items, state.currentFacets, query, totalResults);
    const nextFacets =
      enableRushDelivery || enablePriorityDeliveryPhase2
        ? merge({}, currentFacets)
        : state.nextFacets;
    return {
      ...state,
      currentFacets,
      nextFacets,
      totalResults,
      isAdvanceFacetsEnabled,
      isPriorityDeliveryOffered,
      sessionGenderContext,
      plpGender
    };
  }
  if (type === 'NEXT_FACETS_FECHED') {
    const {
      items,
      query = {},
      totalResults = 0,
      id = 'nextFacets',
      isPriorityDeliveryOffered
    } = action;
    const nextFacets = formatFacets(items, state.nextFacets, query);
    nextFacets.query = query;
    nextFacets.totalResults = totalResults;
    let nextState = { ...state, totalResults, isPriorityDeliveryOffered };
    nextState[id] = nextFacets;
    return nextState;
  }
  if (type === 'SET_NEXT_FACETS') {
    const { query = {} } = action;
    const nextFacets = merge({}, state.currentFacets, { query });
    return { ...state, nextFacets };
  }
  if (type === 'SET_CURRENT_FACETS_QUERY') {
    let { query = {} } = action;
    if (query?.rating?.length > 0) {
      const updatedQuery = query;
      const latestRating = updatedQuery.rating[updatedQuery.rating.length - 1];
      updatedQuery.rating = [];
      updatedQuery.rating.push(latestRating);
      query = updatedQuery;
    }
    const currentFacets = { ...state.currentFacets, query };
    return { ...state, currentFacets };
  }
  if (type === 'CLEAR_NEXT_FACETS') {
    const nextFacets = {};
    return { ...state, nextFacets };
  }
  if (type === 'REMOVE_FACETS') {
    const { id } = action;
    if (id) {
      const nextState = { ...state };
      delete nextState[id];
      return nextState;
    }
    return state;
  }
  return state;
}

function formatFacets(items, prevFacets, query) {
  let { allfilters = '' } = query;
  items = items.filter((item = {}) => {
    let returnValue = true;
    if (item.hideIfCurated) {
      returnValue = false;
    } else if (allfilters === 'true') {
      returnValue = true;
    } else if (item.code != 'newcategory' && !item.visible) {
      returnValue = false;
    }
    return returnValue;
  });
  const facetGroup = normalizeFacetGroups(items);
  const facetItems = normalizeFacetsNext({ results: [], entities: {} }, items);
  const facets = {
    ...prevFacets,
    ...facetGroup,
    ...facetItems,
    // we need firebase flag for facet_type, operator, and per
    // this is for Jio banner ads on plp page
    allfacetsItems: items
    // .find(el => el.code === 'l1l3nestedcategory').values.filter(val => val.count > (totalProductCount*0.05)).map(el => el.code).map(encodeFacets)
  };
  return facets;
}

function setFacetQuery(queryObj, items) {
  let localQueryObj = {};
  items.map(item => {
    const { values = [], code = '' } = item;
    values.filter((value = {}) => {
      if (value.selected) {
        localQueryObj[code] = localQueryObj[code] ? localQueryObj[code] : [];
        localQueryObj[code].push(value.code);
      }
    });
  });
  queryObj.query = localQueryObj;
  return queryObj;
}

/**
 *
 *  Method to set the filter groupby name - All, Common and Advance
 *  By default filter groupby name is All (defaultName)
 * If defaultName parameter is sent then that will be the filter groupby name
 *
 */
function getGroupName(item = {}, defaultName = 'All') {
  let groupInfo = {
    name: defaultName,
    label: defaultName,
    items: []
  };
  return groupInfo;
}

/**
 *
 *  Method to group the filters - All, Common and Advance
 *  By default the items are pushed to All filters (allEntities)
 *  Based on commonFilter flag the items are pushed accordingly (groupEntities)
 *  Items pushed to Common or Advance filter
 *
 */
function normalizeFacetGroups(items) {
  items = items.reduce((acc, item) => {
    if (item.code == 'category') {
    } else if (item.code == 'newcategory') {
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
  return items.reduce(
    (acc, item) => {
      let { code, commonFilter, values = [], isNewCategory } = item;
      let filterCategory = item.commonFilter ? 'Common' : 'Advance';

      if (!acc.groupResults.includes('All')) {
        let allEntities = getGroupName(item);
        acc.groupResults.push(allEntities.name);
        acc.groupEntities[allEntities.name] = allEntities;
      }

      if (!acc.groupResults.includes(filterCategory)) {
        let groupByEntities = getGroupName(item, filterCategory);
        acc.groupResults.push(groupByEntities.name);
        acc.groupEntities[groupByEntities.name] = groupByEntities;
      }
      acc.groupEntities.All.items.push(code);
      acc.groupEntities[filterCategory].items.push(code);
      return acc;
    },
    {
      groupResults: [],
      groupEntities: {}
    }
  );
}

function normalizeFacetsNext(res, items, parentCode) {
  return items.reduce((acc, item) => {
    const { values, facetValueDataList, colorGroups, l1Group, ...rest } = item;
    const { code, selected, hideIfCurated } = rest;

    // verticalcolorfamily
    if (code === 'verticalcolorfamily' && colorGroups && Array.isArray(colorGroups)) {
      rest.colorGroups = colorGroups;

      const allColorValues = [];

      colorGroups.forEach(colorGroup => {
        if (colorGroup.values && Array.isArray(colorGroup.values)) {
          colorGroup.values.forEach(colorValue => {
            const colorKey = `${code}-${colorValue.code}`;
            allColorValues.push(colorKey);
            acc.entities[colorKey] = {
              code: colorValue.code,
              name: colorValue.name,
              count: colorValue.count,
              selected: colorValue.selected,
              query: colorValue.query
            };
          });
        }
      });
      rest.childrens = allColorValues;
    }

    // verticalsizegroupformat
    if (code === 'verticalsizegroupformat' && l1Group && Array.isArray(l1Group)) {
      rest.l1Group = l1Group;

      const allSizeValues = [];
      
      l1Group.forEach(l1GroupItem => {
        if (l1GroupItem.l2Group && Array.isArray(l1GroupItem.l2Group)) {
          l1GroupItem.l2Group.forEach(l2GroupItem => {
            if (l2GroupItem.values && Array.isArray(l2GroupItem.values)) {
              l2GroupItem.values.forEach(sizeValue => {
                const sizeKey = `${code}-${sizeValue.code}`;
                allSizeValues.push(sizeKey);
                acc.entities[sizeKey] = {
                  code: sizeValue.code,
                  name: sizeValue.name,
                  count: sizeValue.count,
                  selected: sizeValue.selected,
                  query: sizeValue.query,
                  priority: sizeValue.priority
                };
              });
            }
          });
        }
      });
      rest.childrens = allSizeValues;
    }

    if (item.code === 'delivery' && !rest?.topValues) {
      rest.topValues = [...values];
    }
    if (rest.topValues) {
      rest.topValues = rest.topValues.reduce((innerAccumlator, topValue) => {
        innerAccumlator.push(`${code}-${topValue.code}`);
        return innerAccumlator;
      }, []);
    }
    if (rest.suggestedValues) {
      rest.suggestedValues = rest.suggestedValues.reduce((innerAccumlator, suggestedValues) => {
        innerAccumlator.push(`${code}-${suggestedValues.code}`);
        return innerAccumlator;
      }, []);
    }
    let key = code;
    if (parentCode) {
      key = `${parentCode}-${code}`;
      if (acc.entities && acc.entities[parentCode] && !acc.entities[parentCode].childrens) {
        acc.entities[parentCode].childrens = [key];
      } else if (acc.entities && acc.entities[parentCode]) {
        acc.entities[parentCode].childrens.push(key);
      }
    }
    const childFacets = values || facetValueDataList;
    acc.results.push(key);
    acc.entities[key] = rest;
    if (childFacets && Array.isArray(childFacets) && childFacets.length > 0) {
      normalizeFacetsNext(acc, childFacets, key);
    }
    return acc;
  }, res);
}
